// extracted by mini-css-extract-plugin
export default {"options":"ImportRestriction_options__eJV-T"};